// angular
import { Component, OnInit } from '@angular/core';

// others
import { VerifyPatientRegistrationService } from './verify-patient-registration.service';
import { AppService } from '../app.service';
import { FormBuilder } from '@angular/forms';
import { BaseComponent } from '../shared/base.component';
import { AuthService } from '../core/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../shared/base.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-verify-patient-registration',
    templateUrl: './verify-patient-registration.component.html',
    styleUrls: ['verify-patient-registration.component.scss'],
    providers: [VerifyPatientRegistrationService]
})

export class VerifyPatientRegistrationComponent extends BaseComponent implements OnInit {

    constructor(public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public appService: AppService,
        public route: ActivatedRoute,
        public service: VerifyPatientRegistrationService,
        public translate: TranslateService,
        public fb: FormBuilder) 
    {
        super(authService, router, baseService, appService);
    }

    registerSuccess = false;
    errorMessage = null;
    srURL = '';

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.isLoading = true;
            this.service.verify({
                token : params['token']
            }).subscribe((res) => {
                this.isLoading = false;
                this.registerSuccess = true;
                this.srURL = res['sr_url'];
                this.translate.use(res['language']);
                localStorage.setItem('language', res['language']);
                window.location.href = res['sr_url'];
            },
            (error) => {
                this.errorMessage = error.error.error;
                this.isLoading = false;
            });
        });
    }

    gotoSR() {
        if (this.srURL) {
            window.location.href = this.srURL;
        }
    }
}
